import ApiService from '@/services/api';
import { Storage } from 'aws-amplify';
import moment from "moment";

const API = new ApiService();

export const state = {
    userData: []
}

export const mutations = {
    SET_USERDATA(state, userData) {
        state.userData = userData;
    }
}

export const getters = {}

// Actions
export const actions = {
    fetchUserProfile({commit}) {
        return new Promise((resolve, reject) => {
            API.get('/profile/info').then(res => {
                commit('SET_USERDATA', res.message.rows);
                resolve(res.message.rows)
            }).catch(err => reject(err));
        });
    },
    fetchUserProfilePicture({commit}) {
        return new Promise((resolve, reject) => {
            API.get('/profile/profile-picture').then(res => {
                commit('SET_USERDATA', res.message.rows);
                resolve(res.message.rows)
            }).catch(err => reject(err));
        });
    },
    // eslint-disable-next-line no-unused-vars
    updateUserProfile({commit}, params) {
        return new Promise((resolve, reject) => {
            API.post('/profile/update', params).then(res => {
                console.log(res);
                resolve(res)
            }).catch(err => reject(err));
        });
    },

    // eslint-disable-next-line no-unused-vars
    uploadBusinessLogo({ commit }, params){
        return new Promise((resolve, reject) => {
        var allowedType = ["jpg","jpeg","png","svg"];
        if(params.type && !allowedType.includes(params.type.toLowerCase())){
            reject("Filetype not allowed");
            return;
        }

        var metadata =  {
            level: 'public',
            expires: moment().add(365, 'days').toDate(),
        }

        if(params.type == 'svg'){
            metadata['contentType'] = 'image/svg+xml';
        }
        
        Storage.put(`business-logos/${params.filename}`, params.base64, metadata)
            .then(stored => {
                console.log(stored);
                resolve(stored.key);
            })
            .catch(err => {
                console.log(err);
                reject(err);
            });
        });
    },
    
    // eslint-disable-next-line no-unused-vars
    uploadProfilePicture({ commit }, params){
    return new Promise((resolve, reject) => {
      var allowedType = ["jpg","jpeg","png","svg"];
      if(params.type && !allowedType.includes(params.type.toLowerCase())){
        reject("Filetype not allowed");
        return;
      }

      var metadata =  {
        level: 'protected',
        expires: moment().add(365, 'days').toDate(),
      }

      if(params.type == 'svg'){
        metadata['contentType'] = 'image/svg+xml';
      }
      
      Storage.put(`profile-picture/${params.filename}`, params.base64, metadata)
        .then(stored => {
            console.log(stored);
            resolve(stored.key);
        })
        .catch(err => {
            console.log(err);
            reject(err);
        });
    });
  }


}